/**
 * Shared Systems-Integrations Handlers
 */

import { SystemsIntegrationsState } from './state';
import { SystemsIntegrationsCommand } from './commands';
import { CommandHandlerMap } from '@commandDrivenStateEngine/core/types';

type ExtractCommand<T extends string> = Extract<SystemsIntegrationsCommand, { type: T }>;

// Tab handlers
const handleSetTab = (
  state: SystemsIntegrationsState,
  cmd: ExtractCommand<'integrations/tab/set'>
): SystemsIntegrationsState => ({
  ...state,
  activeTab: cmd.payload.tab
});

// Connector handlers
const handleSetConnectors = (
  state: SystemsIntegrationsState,
  cmd: ExtractCommand<'integrations/connectors/set'>
): SystemsIntegrationsState => ({
  ...state,
  connectors: cmd.payload.connectors
});

const handleSetConnectorsLoading = (
  state: SystemsIntegrationsState,
  cmd: ExtractCommand<'integrations/connectors/setLoading'>
): SystemsIntegrationsState => ({
  ...state,
  loading: {
    ...state.loading,
    connectorsLoading: cmd.payload.isLoading
  }
});

export const handlers: CommandHandlerMap<SystemsIntegrationsState, SystemsIntegrationsCommand> = {
  'integrations/tab/set': handleSetTab,
  'integrations/connectors/set': handleSetConnectors,
  'integrations/connectors/setLoading': handleSetConnectorsLoading
};
